module.exports = __webpack_public_path__ + "static/media/utility.90203351.svg";